import SignOutButton from '../../Auth/SignOutButton';

const Profile = (props) => {
    return (
        <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
            <div className="flex items-center">
                <div>
                    <img className="inline-block h-10 w-10 rounded-full" src="assets/purpleOneLogo.jpg" alt="Purple One Logo" />
                </div>
                <div className="ml-3">
                    <p className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                        {/* {props.currentUser.name} */}
                    </p>
                    <SignOutButton />
                </div>
            </div>
        </div>
    )
}

export default Profile